<template>
  <section>
    <div class="space-y-4 text-gray-700">
      <div class="flex flex-wrap">
        <div class="w-full">
          <label class="text-gray-smoke font-medium text-sm md:text-lg mb-2 mb-1">Current password</label>
          <input
            class="w-full text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
            type="password"
            v-model="$v.currentPassword.$model"
            :class="{ 'border-red-500': $v.currentPassword.$error }"
          />
          <div v-if="$v.currentPassword.$error">
            <span
              class="text-xs text-red-700"
              v-if="!$v.currentPassword.required"
            >
              Password is required
            </span>
            <span
              class="text-xs text-red-700"
              v-if="!$v.currentPassword.minLength"
            >
              Password minlength is 8
            </span>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap">
        <div class="w-full">
          <label class="text-gray-smoke font-medium text-sm md:text-lg mb-2 mb-1">New password</label>
          <input
            class="w-full text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
            type="password"
            v-model="$v.newPassword.$model"
            :class="{ 'border-red-500': $v.newPassword.$error }"
          />
          <div v-if="$v.newPassword.$error">
            <span class="text-xs text-red-700" v-if="!$v.newPassword.required">
              Password is required
            </span>
            <span class="text-xs text-red-700" v-if="!$v.newPassword.minLength">
              Password minlength is 8
            </span>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap">
        <div class="w-full">
          <label class="text-gray-smoke font-medium text-sm md:text-lg mb-2 mb-1">Confirm password</label>
          <input
            class="w-full text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
            type="password"
            v-model="$v.confirmPassword.$model"
            :class="{ 'border-red-500': $v.confirmPassword.$error }"
          />
          <div v-if="$v.confirmPassword.$error">
            <span
              class="text-xs text-red-700"
              v-if="!$v.confirmPassword.required"
            >
              Password is required
            </span>
            <span
              class="text-xs text-red-700"
              v-if="!$v.confirmPassword.sameAsPassword"
            >
              Confirm Password is not same as Password
            </span>
          </div>
        </div>
      </div>
      <div class="flex justify-end space-x-4">
        <button
          type="button"
          @click="$router.go(-1);"
          class="h-10 px-5 text-green-light transition-colors duration-150 bg-white rounded-lg focus:shadow-outline hover:bg-green-light hover:text-white ring-1 ring-green-light"
        >
          Cancel
        </button>

        <button
          type="submit"
          class="h-10 px-5 text-indigo-100 transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-dark ring-1 ring-green-light"
          @click="onclickChangePassword"
        >
          Save
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { required, sameAs, minLength } from "vuelidate/lib/validators";
import { mapActions } from "vuex";

export default {
  name: "Basics",
  data() {
    return {
      currentPassword: null,
      newPassword: null,
      confirmPassword: null,
    };
  },
  validations: {
    currentPassword: {
      required,
    },
    newPassword: {
      required,
      minLength: minLength(8),
    },
    confirmPassword: {
      required,
      sameAsPassword: sameAs("newPassword"),
    },
  },
  methods: {
    ...mapActions(["postChangePassword"]),

    async onclickChangePassword() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log("invalid");
      } else {
        const data = {
          old_password: this.currentPassword,
          new_password: this.newPassword,
          confirm_password: this.confirmPassword,
        };
        await this.postChangePassword(data);
      }
    },
  },
};
</script>